module.exports = __webpack_public_path__ + "static/SuperAnnotate-c00806d50e75fd00effb92e69c67dc71.jpg";